import { List } from 'immutable';
import { defaultMemoize } from 'reselect';

const isSalesAndMarketingTaxonomyLoading = defaultMemoize(
    (data) => data.get('loaded') === 'loading',
);

const getSalesAndMarketingTaxonomyCategories = defaultMemoize(
    (data) => data.getIn(['catSalesAndMarketing', 'categories'], List()),
);

export {
    isSalesAndMarketingTaxonomyLoading,
    getSalesAndMarketingTaxonomyCategories,
};
